import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { PaymentOptionPropertiesInterface } from '../../services/exports/Interfaces';
import collect from 'collect.js';
import { PaymentOptionsStoreInterface } from '../types';

export default createSlice({
  name: REDUX_STORE_SLICES.PAYMENT_OPTIONS,
  initialState: {
    payment_options: [],
  },
  reducers: {
    setPaymentOptions: (
      state: PaymentOptionsStoreInterface,
      action: PayloadAction<PaymentOptionPropertiesInterface[]>,
    ) => {
      state.payment_options = action.payload;
    },
    addPaymentOption: (state: PaymentOptionsStoreInterface, action) => {
      state.payment_options = collect(state.payment_options)
        .push(action.payload)
        .map((paymentMethod: PaymentOptionPropertiesInterface) => {
          return {
            ...paymentMethod,
            is_default: paymentMethod?.payment_method_id === action.payload?.payment_method_id,
          };
        })
        .toArray();
    },
    removePaymentOption: (state: PaymentOptionsStoreInterface, action) => {
      const { removePaymentOptionId, newDefaultPaymentOption } = action.payload;

      state.payment_options = collect(state.payment_options)
        .reject((item) => item.id === removePaymentOptionId)
        .map((paymentMethod: PaymentOptionPropertiesInterface) => {
          return {
            ...paymentMethod,
            is_default: paymentMethod?.payment_method_id === newDefaultPaymentOption?.payment_method_id,
          };
        })
        .toArray();
    },
    reset: (state: PaymentOptionsStoreInterface) => {
      state.payment_options = [];
    },
  },
});

export const props = (state: PaymentOptionsStoreInterface) => state;
